<app-base-grid-page
    [posts]="posts"
    [isLoading]="isLoading"
    [itemsCount]="itemsCount"
    [pagesCount]="pagesCount"
    thumbnailType="CRAFT"
    title="Lucru manual"
    searchPlaceholder="Caută activități"
    (getData)="getData($event)"
></app-base-grid-page>
